import { BRANCH_ENVIRONMENT_PRODUCTION, BRANCH_ENVIRONMENT_SCRATCH } from '@takeshape/branches';

export const NAME = 'branches';
export const DEFAULT_BRANCH = BRANCH_ENVIRONMENT_PRODUCTION;
export const SCRATCH_BRANCH = BRANCH_ENVIRONMENT_SCRATCH;
